<template>
  <Dropdown
    :transfer="true"
    trigger="click"
    placement="left-start"
    style="font-size: 22px"
    v-if="options.length > 0"
  >
    <a style="color: #515a73">
      <Icon type="md-more"></Icon>
    </a>
    <DropdownMenu slot="list">
      <template v-for="(option, key) in options">
        <DropdownItem
          :key="key"
          v-if="option.show"
          @click.native="onSelect(id, option.label, key + 1)"
          :style="{ color: option.textColor || '#515a73' }"
        >
          <Icon :type="option.icone" />
          {{ option.label }}
        </DropdownItem>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  props: {
    id: Number,
    onSelect: Function,
    options: Array,
  },
};
</script>
